import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { IndicadorVendaVarejoFiltroService } from './indicador-venda-varejo-filtro.service';
import { IndicadorVendaVarejoService } from './indicador-venda-varejo.service';

declare var $: any;

@Component({
  selector: 'app-indicador-venda-varejo',
  templateUrl: './indicador-venda-varejo.component.html',
  styleUrls: ['./indicador-venda-varejo.component.scss']
})
export class IndicadorVendaVarejoComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  origem = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  carregando: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Number": "businessIntelligence.indicadorVenda.dealerCod",
    "Dealer Name": "businessIntelligence.indicadorVenda.dealerName",
    "Data": "businessIntelligence.indicadorVenda.dataEmissao",
    "PartNumber": "businessIntelligence.indicadorVenda.partNumber",
    "Descrição": "businessIntelligence.indicadorVenda.descricaoItem",
    "Quantidade": "businessIntelligence.indicadorVenda.quantidade",
    "Valor de Venda": "businessIntelligence.indicadorVenda.valorVenda",
    "Origem": "businessIntelligence.indicadorVenda.origem",
    "CPF/CNPJ": "businessIntelligence.indicadorVenda.documento",
    "Inventário Final Qtd.": "businessIntelligence.indicadorVenda.inventFinalQtd",
  }

  constructor(private service: IndicadorVendaVarejoService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: IndicadorVendaVarejoFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'indicador-venda-varejo';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      origem: [''],
      partNumber: [''],
      documento: [''],
      original: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.preencherOrigem();

    this.carregando = true;

    this.cols = [
      { field: 'codDealer', header: 'businessIntelligence.indicadorVenda.dealerCod', headerBr: 'Dealer Number', headerGb: 'Dealer Number' },
      { field: 'nome', header: 'businessIntelligence.indicadorVenda.dealerName', headerBr: 'Dealer Name', headerGb: 'Dealer Name' },
      { field: 'data', header: 'businessIntelligence.indicadorVenda.dataEmissao', headerBr: 'Data', headerGb: 'Date' },
      { field: 'partNumber', header: 'businessIntelligence.indicadorVenda.partNumber', headerBr: 'PartNumber', headerGb: 'PartNumber' },
      { field: 'categoria', header: 'businessIntelligence.indicadorVenda.categoria', headerBr: 'Categoria', headerGb: 'Category' },
      { field: 'subgrupo', header: 'businessIntelligence.indicadorVenda.subgrupo', headerBr: 'Subgroupo', headerGb: 'Subgroup' },
      { field: 'descricaoItem', header: 'businessIntelligence.indicadorVenda.descricaoItem', headerBr: 'Descrição', headerGb: 'Description' },
      { field: 'quantidade', header: 'businessIntelligence.indicadorVenda.quantidade', headerBr: 'Quantidade', headerGb: 'Amount' },
      { field: 'valorVenda', header: 'businessIntelligence.indicadorVenda.valorVenda', headerBr: 'Valor', headerGb: 'Value' },
      { field: 'origem', header: 'businessIntelligence.indicadorVenda.origem', headerBr: 'Origem', headerGb: 'Origin' },
      { field: 'documento', header: 'businessIntelligence.indicadorVenda.documento', headerBr: 'CPF/CNPJ', headerGb: 'EN/SSN' },
      { field: 'nomeCliente', header: 'businessIntelligence.indicadorVenda.cliente', headerBr: 'Cliente', headerGb: 'Client' },
      { field: 'email', header: 'businessIntelligence.indicadorVenda.email', headerBr: 'E-mail', headerGb: 'E-mail' },
      { field: 'ddd', header: 'businessIntelligence.indicadorVenda.ddd', headerBr: 'DDD', headerGb: 'DDD' },
      { field: 'telefone', header: 'businessIntelligence.indicadorVenda.telefone', headerBr: 'Telefone', headerGb: 'Telephone' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherOrigem() {
    this.origem = [
      { nome: 'A&L', valor: "1" },
      { nome: 'Balcão', valor: "2" },      
      { nome: 'Oficina', valor: "3" },
      { nome: 'Outros', valor: "4" }
    ];
  }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.origem.value,
      this.f.partNumber.value, this.f.documento.value, this.f.original.value).subscribe(dados => {
        this.dealersDados = dados.dealers;
        this.orderByDate();

        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");
          element.data = element.data.substring(0, 10);
        });

        this.carregando = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.origem.value
      || this.f.partNumber.value
      || this.f.documento.value
      || this.f.original.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.documento.setValue('');
    this.f.origem.setValue('');
    this.f.partNumber.setValue('');
    this.f.original.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.indicadorVenda.dealerCod") {
      return "Cód. Dealer";
    }
    if (item == "businessIntelligence.indicadorVenda.dealerName") {
      return "Dealer";
    }
    if (item == "businessIntelligence.indicadorVenda.dataEmissao") {
      return "Data";
    }
    if (item == "businessIntelligence.indicadorVenda.partNumber") {
      return this.translate.currentLang == "br" ? "PartNumber" : "partNumber";
    }
    if (item == "businessIntelligence.indicadorVenda.categoria") {
      return this.translate.currentLang == "br" ? "Categoria" : "Category";
    }
    if (item == "businessIntelligence.indicadorVenda.subgrupo") {
      return this.translate.currentLang == "br" ? "Subgrupo" : "Subgrup";
    }
    if (item == "businessIntelligence.indicadorVenda.descricaoItem") {
      return this.translate.currentLang == "br" ? "Descrição" : "Description";
    }
    if (item == "businessIntelligence.indicadorVenda.quantidade") {
      return this.translate.currentLang == "br" ? "Quantidade" : "Amount";
    }
    if (item == "businessIntelligence.indicadorVenda.valorVenda") {
      return this.translate.currentLang == "br" ? "Valor de Venda" : "Sale Value";
    }
    if (item == "businessIntelligence.indicadorVenda.origem") {
      return this.translate.currentLang == "br" ? "Origem" : "Origin";
    }
    if (item == "businessIntelligence.indicadorVenda.documento") {
      return this.translate.currentLang == "br" ? "CPF/CNPJ" : "EN/SSN";
    }
    if (item == "businessIntelligence.indicadorVenda.cliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }
    if (item == "businessIntelligence.indicadorVenda.email") {
      return "E-mail";
    }
    if (item == "businessIntelligence.indicadorVenda.ddd") {
      return "DDD";
    }
    if (item == "businessIntelligence.indicadorVenda.telefone") {
      return this.translate.currentLang == "br" ? "Telefone" : "Telephone";
    }
  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.documento.value, this.f.origem.value,
      this.f.partNumber.value, this.f.original.value).subscribe(dados => {
        registros = dados.dealers;
        this.orderByDate();

        registros.forEach(dados => {
          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          // dados.valorVenda = valorFormatado.replace("R$", "");
          dados.data = dados.data.substring(0, 10);
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          // this.exportExcelService.colunasFormatacao = [0];
          // this.exportExcelService.colunasFormatacao = [6];
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregando = true;
        this.getAll();
      });
  }

}
